import { render, staticRenderFns } from "./my-profile.page.vue?vue&type=template&id=14700405&scoped=true"
import script from "./my-profile.page.vue?vue&type=script&lang=js"
export * from "./my-profile.page.vue?vue&type=script&lang=js"
import style0 from "./my-profile.page.vue?vue&type=style&index=0&id=14700405&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14700405",
  null
  
)

export default component.exports